/**
 * 获取年-月-日 时:分:秒
 * @param {datatime} newdata
 */
export function getdatatime(newdata) {
    let date = new Date(newdata);
    let yy = date.getFullYear();
    let mm = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
    let dd = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    let hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    let mf = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    let ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    let gettime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss;
    return gettime
}

/**
 * 获取年-月-日 时:分:秒
 * @param {datatime} date
 * @param {formatDate} fmt 'yyyy-MM-dd hh:mm:ss'
 */
export function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    }
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + ''
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length))
        }
    }
    return fmt
}

/**
 * comparedate 比较两个日期的大小 2021-06-15 刘敏
 * @param {date1} 开始日期
 * @param {date2} 结束日期
 */
export function comparedate(date1, date2) {
    let oDate1 = new Date(date1);
    let oDate2 = new Date(date2);
    if (date1 != '' && date2 != '' && oDate1.getTime() > oDate2.getTime()) {
        return true;
    }
    else {
        return false;
    }
}

//获取当前日期
export function getData() {
    let myDate = new Date;
    let year = myDate.getFullYear(); //获取当前年
    let mon = myDate.getMonth() + 1; //获取当前月
    let date = myDate.getDate(); //获取当前日
    mon = String(mon).length == 1 ? '0' + mon : mon;
    date = String(date).length == 1 ? '0' + date : date;
    return year + '-' + mon + '-' + date;
}
//获取当年的开始日期
export function currentDateDay() {
    let myDate = new Date;
    let year = myDate.getFullYear(); //获取当前年
    return year + '-01'+'-' + '01';
}

//获取昨天日期
export function getYesterDay() {

    let myDate = new Date;
    myDate.setTime(myDate.getTime() - (24 * 60 * 60 * 1000));
    let year = myDate.getFullYear(); //获取当前年
    let mon = myDate.getMonth() + 1; //获取当前月
    let date = myDate.getDate(); //获取当前日
    mon = String(mon).length == 1 ? '0' + mon : mon;
    date = String(date).length == 1 ? '0' + date : date;
    return year + '-' + mon + '-' + date;
}

//获取上周的日期
export function getLastweek() {

    let myDate = new Date;
    myDate.setTime(myDate.getTime() - (7 * 24 * 60 * 60 * 1000));
    let year = myDate.getFullYear(); //获取当前年
    let mon = myDate.getMonth() + 1; //获取当前月
    let date = myDate.getDate(); //获取当前日
    mon = String(mon).length == 1 ? '0' + mon : mon;
    date = String(date).length == 1 ? '0' + date : date;
    return year + '-' + mon + '-' + date;
}

//获取上个月的当前日期
export function getLastMonth() {
    let date = new Date();

    //获取30天前得日期
    let lastDate = new Date(date - 1000 * 60 * 60 * 24 * 30);//最后30天可以更改，意义：是获取多少天前的时间
    let lastY = lastDate.getFullYear();
    let lastM = lastDate.getMonth() + 1;
    let lastD = lastDate.getDate();
    let LDate = lastY + "-" + (lastM < 10 ? "0" + lastM : lastM) + "-" + (lastD < 10 ? "0" + lastD : lastD);//得到30天前的时间
    return LDate
}


// WEBPACK FOOTER //
// ./src/utils/my.js